import(/* webpackMode: "eager", webpackExports: ["ClientSidePagination"] */ "/app/apps/ui/src/app/[locale]/_components/Pagination/index.client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/ui/src/app/[locale]/_components/Pagination/PaginationRenderer.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/ui/src/app/[locale]/blog/_components/AuthorBlock.module.css");
;
import(/* webpackMode: "eager" */ "/app/apps/ui/src/app/[locale]/blog/_components/BlogArticles.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["BlogCard"] */ "/app/apps/ui/src/app/[locale]/blog/_components/BlogCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogNavigation"] */ "/app/apps/ui/src/app/[locale]/blog/_components/BlogNavigation.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EditorsPick"] */ "/app/apps/ui/src/app/[locale]/blog/_components/EditorsPick.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/ui/src/app/[locale]/blog/_components/SearchInput.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/ui/src/components/elementary/AppLink/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/apps/ui/src/components/elementary/CkEditorRenderer/CkEditorDefaultStyles.css");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/app/apps/ui/src/components/elementary/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OptimizedImage"] */ "/app/apps/ui/src/components/elementary/OptimizedImage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/packages/design-system/src/breakpoints.css");
